import React from 'react';
import Header from '../components/Header';
import FooterLinks from '../components/FooterLinks';
import CookieNoticeSection from '../components/CookieNoticeSection';

const heroStyles = {
  backgroundImage: "url('https://images.pexels.com/photos/1181676/pexels-photo-1181676.jpeg?auto=compress&cs=tinysrgb&w=1920')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

const CookieNotice = () => (
  <div className="min-h-screen bg-white text-gray-800">
    <Header />
    <div className="mt-32 sm:mt-36 lg:mt-32">

    <section className="relative w-full min-h-[50vh] sm:min-h-[55vh] lg:min-h-[60vh] flex items-end" style={heroStyles}>
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 pb-16 sm:pb-20 lg:pb-24 text-center text-white">
        <p className="text-xs tracking-widest uppercase text-white/80">Legal Notice</p>
        <h1 className="mt-4 text-4xl md:text-5xl font-light">
          Cookie Notice
        </h1>
        <p className="mt-4 text-base md:text-lg text-white/85">
          Transparency matters to us. Below you can explore how Testa Care Careers uses cookies to keep your visit secure,
          personalised, and effortless right across our recruitment experience.
        </p>
      </div>
    </section>

    <CookieNoticeSection />

    <section className="py-12 px-8" style={{ backgroundColor: '#f5f5f5' }}>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8">
          <div className="md:w-5/12 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-medium text-gray-900">
              Ready to start your journey with us?
            </h2>
          </div>
          <div className="md:w-4/12">
            <a
              href="/join-our-team"
              className="block text-center px-8 py-3 text-white text-base font-medium hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2f4c74' }}
            >
              Apply Today
            </a>
          </div>
        </div>
      </div>
    </section>

    <FooterLinks />
    </div>
  </div>
);

export default CookieNotice;

